import { useQueryClient } from '@tanstack/react-query';
import type { NonPendingEventRsvpStatus } from 'models';
import { useMutation } from 'query';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { getCalendarPrincipalEventsListQueryKey } from 'features/calendar/queries';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { getNodeTodosInfiniteQueryKey } from 'features/todos/queries/use-node-todos-query/keys';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { getTodosInfiniteQueryKey } from 'features/todos/queries/use-todos-query/keys';
import { updateNodeEventUserStatus } from '../../services';
import { getNodeEventDetailQueryKey, getNodeEventsInfiniteQueryKey } from '../keys';

export const useUpdateNodeEventUserStatusMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<undefined, { id: string; statusToApply: NonPendingEventRsvpStatus }>({
    async mutationFn({ id, statusToApply }) {
      const response = await updateNodeEventUserStatus({
        body: { rsvp: statusToApply },
        routeParams: { eventId: id },
      });
      return response.data;
    },

    async onSettled(_, __, params) {
      await queryClient.invalidateQueries({ queryKey: getNodeEventsInfiniteQueryKey({}) });
      await queryClient.invalidateQueries({ queryKey: getNodeTodosInfiniteQueryKey({}) });
      await queryClient.invalidateQueries({ queryKey: getTodosInfiniteQueryKey({}) });
      await queryClient.invalidateQueries({ queryKey: getNodeEventDetailQueryKey({ eventId: params.id }) });
      await queryClient.invalidateQueries({ queryKey: getCalendarPrincipalEventsListQueryKey({}) });
    },
  });
};
